import React, { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import { LanguageProvider } from "@/context/LanguageContext";
import { CartProvider } from "@/context/CartContext";

// Lazy-load non-landing pages to keep initial bundle small.
const CheckoutPage = lazy(() => import("@/pages/CheckoutPage"));
const OrderConfirmationPage = lazy(() =>
  import("@/pages/OrderConfirmationPage")
);
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const TestimonialFormPage = lazy(() => import("@/pages/TestimonialFormPage"));
const ProductPage = lazy(() => import("@/pages/ProductPage"));
const BlogIndexPage = lazy(() => import("@/pages/BlogIndexPage"));
const BlogPostPage = lazy(() => import("@/pages/BlogPostPage"));

const RouteFallback = () => (
  <div className="min-h-screen bg-[#1A1322] flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-[#FBAD18] border-t-transparent rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <CartProvider>
          <BrowserRouter>
            <Suspense fallback={<RouteFallback />}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/producto/:slug" element={<ProductPage />} />
                <Route path="/blog" element={<BlogIndexPage />} />
                <Route path="/blog/:slug" element={<BlogPostPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/contacto" element={<ContactPage />} />
                <Route
                  path="/testimonios/nuevo"
                  element={<TestimonialFormPage />}
                />
                <Route
                  path="/orden/:orderNumber"
                  element={<OrderConfirmationPage />}
                />
              </Routes>
            </Suspense>
          </BrowserRouter>
        </CartProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
